import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Col, Descriptions, List, Modal, Typography } from 'antd';
import PropTypes from 'prop-types';
import {
	getactionMessages,
	getClientMessages,
	getFields,
	getJobMessages,
	getModalMessages,
	getRequestMessages,
} from '../../constants/messages';
import { REQUESTTYPES } from '../Jobs/constants';

let moment = require('moment');

let requestMessages = getRequestMessages(),
	clientMessages = getClientMessages(),
	fieldMessages = getFields(),
	actionMessages = getactionMessages(),
	modalMessages = getModalMessages(),
	jobMessages = getJobMessages();

const messages = {
	...requestMessages,
	...clientMessages,
	...fieldMessages,
	...actionMessages,
	...modalMessages,
	...jobMessages,
};

const { Text } = Typography;

const ViewRequestModal = ({ request, openModal, handleCancel }) => {
	const intl = useIntl();
	const {
		contact: { name, email, cellphone },
		client,
		createdAt,
		bought,
		leased,
		observations,
		vehicles,
		createdBy,
		type,
		devices,
	} = request;
	const vehiclesParse = JSON.parse(vehicles);
	const requestType = Object.values(REQUESTTYPES).find((rt) => rt.id === type);

	return (
		<Modal
			title={intl.formatMessage({ ...messages.viewRequest })}
			open={openModal}
			onCancel={handleCancel}
			footer={[
				<Button key="close" onClick={handleCancel}>
					<FormattedMessage {...messages.close} />
				</Button>,
			]}
		>
			<Descriptions layout="vertical" size="small" bordered column={1}>
				<Descriptions.Item label={intl.formatMessage({ ...messages.request })}>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.client })}: `}</Text>
						<Text>{client.name}</Text>
					</Col>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.requestType })}: `}</Text>
						<Text>{intl.formatMessage({ ...messages[requestType.intl] })}</Text>
					</Col>
					{REQUESTTYPES.INSTALLATION.id === type && (
						<span>
							<Col span={24}>
								<Text strong>{`${intl.formatMessage({ ...messages.boughtGPSs })}: `}</Text>
								<Text>{bought}</Text>
							</Col>
							<Col span={24}>
								<Text strong>{`${intl.formatMessage({ ...messages.leasedGPSs })}: `}</Text>
								<Text>{leased}</Text>
							</Col>
						</span>
					)}
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.requestedBy })}: `}</Text>
						<Text>{createdBy.name}</Text>
					</Col>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.dateRequested })}: `}</Text>
						<Text>{moment(createdAt).locale('es').format('dddd, LL')}</Text>
					</Col>
				</Descriptions.Item>
				<Descriptions.Item label={intl.formatMessage({ ...messages.contactName })}>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.name })}: `}</Text>
						<Text>{name}</Text>
					</Col>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.clientTelephone })}: `}</Text>
						<Text>{cellphone}</Text>
					</Col>
					<Col span={24}>
						<Text strong>{`${intl.formatMessage({ ...messages.email })}: `}</Text>
						<Text>{email ? email : ''}</Text>
					</Col>
				</Descriptions.Item>
				<Descriptions.Item label={intl.formatMessage({ ...messages.details })}>
					{(type === REQUESTTYPES.REVISION.id || type === REQUESTTYPES.UNINSTALLATION.id) && (
						<Col span={24}>
							<Text strong>{`${intl.formatMessage({ ...messages.devices })}: `}</Text>
							<Text>{JSON.parse(devices).join(', ')}</Text>
						</Col>
					)}
					<List
						itemLayout="vertical"
						dataSource={vehiclesParse}
						renderItem={(vehicle) => (
							<List.Item>
								<Col span={24}>
									<Text strong>{`${intl.formatMessage({ ...messages.platePlaceholder })}: `}</Text>
									<Text>{vehicle.plate}</Text>
								</Col>
								<Col span={24}>
									<Text strong>{`${intl.formatMessage({ ...messages.brandPlaceholder })}: `}</Text>
									<Text>{vehicle.brand}</Text>
								</Col>
								<Col span={24}>
									<Text strong>{`${intl.formatMessage({ ...messages.modelPlaceholder })}: `}</Text>
									<Text>{vehicle.model}</Text>
								</Col>
							</List.Item>
						)}
					/>
				</Descriptions.Item>
				<Descriptions.Item label={intl.formatMessage({ ...messages.observations })}>
					<Col span={24}>
						<Text>{observations ? observations : ''}</Text>
					</Col>
				</Descriptions.Item>
			</Descriptions>
		</Modal>
	);
};

ViewRequestModal.propTypes = {
	request: PropTypes.object.isRequired,
	openModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
};

export default ViewRequestModal;
